import React from "react";
import { Box, Skeleton } from "@mui/material";

const ChartLoading = ({ compact = false }) => {
	const bars = compact ? ["76%", "54%"] : ["100%", "82%", "64%"];

	return (
		<Box
			sx={{
				width: compact ? 92 : "min(280px, 72%)",
				display: "flex",
				flexDirection: "column",
				gap: compact ? 0.65 : 1,
			}}
		>
			{bars.map((width, index) => (
				<Skeleton
					key={`${width}-${index}`}
					variant="rounded"
					animation="wave"
					width={width}
					height={compact ? 8 : 10}
					sx={{ borderRadius: 999 }}
				/>
			))}
		</Box>
	);
};

export default ChartLoading;
